/**
 * Global JS bootstrap entry.
 * Exposes Bootstrap on `window.bootstrap` and loads shared UI dependencies.
 */
import $ from 'jquery'
import '@popperjs/core'
import './cmp-consent-runtime'

import '../scss/index.scss'

// Import jQuery UI widgets
import 'jquery-ui/ui/widgets/sortable'
import 'jquery-ui/ui/disable-selection'

import 'jquery-ui/ui/widgets/droppable'

import * as bootstrap from 'bootstrap'

window.$ = $
window.jQuery = $
window.bootstrap = bootstrap
